import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
//import { CreditCard, CreditCardValidators } from 'angular-cc-library'; // replaced
//import { CreditCardDirectivesModule } from 'ngx-credit-cards';
import { CreditCardHelper } from '../../helpers/credit-card.helpers';
//import * as moment from 'moment';
import moment from 'moment';
import { ValidatorsService } from '../../services/validators.service';
import { debounceTime } from 'rxjs';

export interface ICreditCardForm {
  fullName: string;
  number: number;
  cvc: number;
  expirationMonth: number;
  expirationYear: number;
  expirationDate: string;
  type: string;
  typeId: number;
  _valid: boolean
}

@Component({
    selector: 'shared-credit-card-form',
    templateUrl: './credit-card-form.component.html',
    styleUrls: ['./credit-card-form.component.scss'],
    standalone: false
})
export class CreditCardFormComponent implements OnInit {
  form: FormGroup;
  formErrors: Map<string, string> = new Map<string, string>();
  patternReference: any = {};

  @Output() onSubmit: EventEmitter<ICreditCardForm> = new EventEmitter<ICreditCardForm>();

  private _submitted: boolean;

  @Input() set submitted(value: boolean)
  {
    this._submitted = value; 
  }

  get submitted(): boolean {
    return this._submitted;
  }

    // convenience getter for easy access to form fields
  get f() { return this.form.controls; }

  minExpirationDate: string;
  maxExpirationDate: string;

  constructor(private fb: FormBuilder, public validators: ValidatorsService) { }

  ngOnInit() {

    let date = new Date();

    /*
    this.form = this.fb.group({
      'fullName': ['', this.validators.formBuilderValidationInitializer(true, null, false)],
      'number': [, this.validators.formBuilderValidationInitializer(true, null, false, true)],
      'cvc': [, this.validators.formBuilderValidationInitializer(true, 4)],
      // 'expiry': ['', this.validators.formBuilderValidationInitializer(true, null, false],      
      'expiryMonth': ['', this.validators.formBuilderValidationInitializer(true, 5)],
      'expiryYear': ['', this.validators.formBuilderValidationInitializer(true, null, false, false, [0, 15])]
    });
    */
    this.form = this.fb.group({

      fullName: this.fb.control('', {
        validators: this.validators.formBuilderValidationInitializer(true, null, false)
      }),

      number: this.fb.control('', {
        validators: this.validators.formBuilderValidationInitializer(true, null, false, true)
      }),

      cvc: this.fb.control('', {
        validators: this.validators.formBuilderValidationInitializer(true, 4)
      }),

      // expiry: intentionally removed as per your comment
      // expiry: this.fb.control('', {
      //   validators: this.validators.formBuilderValidationInitializer(true, null, false)
      // }),

      expiryMonth: this.fb.control('', {
        validators: this.validators.formBuilderValidationInitializer(true, 5)
      }),

      expiryYear: this.fb.control('', {
        validators: this.validators.formBuilderValidationInitializer(true, null, false, false, [0, 15])
      }),

    });

    /*
    this.form["patternReference"] = {
      fullName: null,
      number: null,
      cvc: 4,
      //expiry: null,
      expiryMonth: 5,
      expiryYear: null,
    };
    */
    this.patternReference = {
      fullName: null,
      number: null,
      cvc: 4,
      // expiry: null,
      expiryMonth: 5,
      expiryYear: null
    };

    //this.validators.trackInputChange(this.form);
    this.validators.trackInputChange(this.form, this.patternReference);
   
    this.minExpirationDate = `${date.getFullYear()}-${("0" + (date.getMonth() + 1)).slice(-2)}-${("0" + (date.getDate() + 1)).slice(-2)}`;

    date.setFullYear(date.getFullYear() + 20);
    this.maxExpirationDate = `${date.getFullYear()}-${("0" + (date.getMonth() + 1)).slice(-2)}-${("0" + (date.getDate() + 1)).slice(-2)}`;


    //this.form.get('number')?.valueChanges.pipe(debounceTime(0)).subscribe(() => this.submit());
  }

  async submitMonth() {
    let monthValue: number = this.form.get('expiryMonth').value;

    if (monthValue != null) {
      if (monthValue > 12) {
        this.form.get('expiryMonth').setValue(12);
      }

      if (monthValue < 0) {
        this.form.get('expiryMonth').setValue(1);
      }
    }


    this.submit();
  }

  async submitYear() {
    let date = new Date();
    let currentYear = date.getFullYear();
    let maxYear = currentYear + 15;  

    let yearValue: number = this.form.get('expiryYear').value;

    if (yearValue != null) {
      if (yearValue.toString().length != 4) {
        return;
      }
      
      if (yearValue > maxYear) {
        this.form.get('expiryYear').setValue(maxYear);
      }

      if (yearValue < date.getFullYear()) {
        this.form.get('expiryYear').setValue(currentYear);
      }
    }

    this.submit();
  }

  async submit() {
    //sanitizing
    this.form.setValue(this.validators.multiSanitizerInput(this.form.value));

    //CVC custom validation
    let cvcLength: number = this.form.get('cvc').value;
    
    if (cvcLength != null) {
      if (cvcLength.toString().length > 5) {
        this.form.get('cvc').setValue(cvcLength.toString().substring(0, 5));
      }
    }
    
    if (!this.form.valid)
      return;

 

    this.formErrors.clear();
   
    this.submitEmit();
  }

  formFieldValidator(field: string, errorType: string) {
    let invalid = this.submitted && this.f[field] && this.f[field].errors && this.f[field].errors[errorType];
    this.submitEmit();
    return invalid;
  }

  submitEmit() {
   //debugger;
   // let expiration = this.form.get('expiry').value.split("/");
    const cardNumber = this.form.get('number').value;
    let expirationDate = 1;
    let currentDate = new Date();
    if(this.form.get('expiryYear').value == currentDate.getFullYear() && this.form.get('expiryMonth').value == currentDate.getMonth() + 1){
      expirationDate = currentDate.getDate();
    }

    const type = this.validators.cardType(cardNumber);

    this.onSubmit.emit({
      fullName: this.form.get('fullName').value,
      number: cardNumber,
      cvc: this.form.get('cvc').value,
      /*expirationMonth: parseInt(expiration[0]),
      expirationYear: parseInt(expiration[1]),
      expirationDate: parseInt(expiration[1]) + '-' +  parseInt(expiration[0]) + '-' + this.pad(day.toString(), 2),*/
      //expirationDate: this.form.get('expiry').value,
     expirationMonth: this.form.get('expiryMonth').value,
     expirationYear: this.form.get('expiryYear').value,
     expirationDate: this.form.get('expiryYear').value + '-' + this.pad(this.form.get('expiryMonth').value, 2) + '-' + this.pad(expirationDate.toString(), 2),
      type: type,
      //type: CreditCard.cardType(cardNumber),
      typeId: this.validators.getTypeFromName(type),
      //typeId: CreditCardHelper.getTypeFromName(CreditCard.cardType(cardNumber)),
      _valid: this.form.valid
    });
  } 

  pad(n, width) {
    let z = '0';
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
  }

  addSlashes (element) {	
    let ele = <HTMLInputElement>document.getElementById("dateInput");
    let transformedValue = ele.value.split('/').join('');    // Remove slash (/) if mistakenly entered.
    if(transformedValue.length < 4 && transformedValue.length > 0){
        let finalVal = transformedValue.match(/.{1,2}/g).join('/');

        (<HTMLInputElement>document.getElementById("dateInput")).value = finalVal;
    }
}
}
